import {
	AfterViewInit,
	Component,
	ElementRef,
	inject,
	input,
	Renderer2,
	viewChild,
	ChangeDetectionStrategy,
} from "@angular/core";
import { UtilService } from "common/util.service";

import { TranslateModule } from "@ngx-translate/core";
import { NgStyle } from "@angular/common";

@Component({
	selector: "stages-spin",
	templateUrl: "./spin.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule, NgStyle],
})
export class SpinComponent implements AfterViewInit {
	readonly titleKey = input<string>("loading");

	private utilService = inject(UtilService);
	private renderer = inject(Renderer2);

	private readonly spinElement = viewChild.required<ElementRef>("spin");

	readonly size = input<string>("s");

	readonly color = input<string>();

	strokeWidth: string = "6px";

	needsFallBack: boolean;

	constructor() {
		this.needsFallBack =
			this.utilService.browserIsIE() || this.utilService.browserIsEdge() || this.utilService.deviceIsIOS();
	}

	ngAfterViewInit(): void {
		if (this.needsFallBack) {
			this.getSize();
		}
	}

	getSize(): string {
		let sizeValue;
		let borderWidth;

		switch (this.size()) {
			case "sm": {
				sizeValue = "20px";
				borderWidth = "2px";
				this.strokeWidth = "6px";
				break;
			}
			case "sm+": {
				sizeValue = "28px";
				borderWidth = "2px";
				this.strokeWidth = "6px";
				break;
			}
			case "md": {
				sizeValue = "50px";
				borderWidth = "5px";
				this.strokeWidth = "6px";
				break;
			}
			case "lg": {
				sizeValue = "80px";
				borderWidth = "8px";
				this.strokeWidth = "6px";
				break;
			}
			case "xl": {
				sizeValue = "230px";
				borderWidth = "23px";
				this.strokeWidth = "3px";
				break;
			}
			default: {
				sizeValue = "20px";
				borderWidth = "2px";
				this.strokeWidth = "6px";
				break;
			}
		}

		if (this.needsFallBack) {
			this.renderer.setAttribute(
				this.spinElement().nativeElement,
				"style",
				"width:" +
					sizeValue +
					"; height: " +
					sizeValue +
					"; border-radius:" +
					sizeValue +
					"; border-width:" +
					borderWidth +
					"; animation-duration: 1s",
			);
		}

		return sizeValue;
	}
}
